import { createFileRoute } from '@tanstack/react-router'
import { TopBar } from '../app/AppShell'
import { useSession } from '../auth/useSession'
import { VerifyEmail } from '../auth/VerifyEmail'
import { SignIn } from '../unauth/SignIn'
import { SessionSkeleton } from '../auth/SessionSkeleton'
import { ProblemState } from '../ui/states/ProblemState'
import { WorkspacePicker } from '../features/workspace/WorkspacePicker'

function Bootstrap() {
  const session = useSession()
  const navigate = Route.useNavigate()

  if (session.status === 'loading') {
    return <SessionSkeleton />
  }

  if (session.status === 'error') {
    return (
      <>
        <TopBar />
        <main className="flex min-h-[calc(100dvh-4rem)] items-center justify-center bg-accent/30 px-4 py-8">
          <ProblemState
            error={session.error}
            title="The session could not be checked"
            scale="page"
            onRetry={session.retry}
          />
        </main>
      </>
    )
  }

  if (session.status === 'unauthenticated') {
    return <SignIn onSignIn={session.signIn} />
  }

  if (session.status === 'unverified') {
    return <VerifyEmail session={session} />
  }

  return (
    <>
      <TopBar />
      <main className="mx-auto max-w-6xl p-4 sm:p-6">
        <WorkspacePicker
          onSelectWorkspace={(workspaceId) => {
            void navigate({ to: '/w/$workspaceId', params: { workspaceId } })
          }}
        />
      </main>
    </>
  )
}

export const Route = createFileRoute('/')({
  component: Bootstrap,
})
